import { Button } from "@/components/ui/button";
import { Sparkles, Calculator } from "lucide-react";
import { Link } from "react-router-dom";
import { WaitlistCTA } from "@/components/WaitlistCTA";

export const CTASection = () => {
  return (
    <section className="py-16 sm:py-24 px-4 bg-muted/30">
      <div className="container mx-auto max-w-3xl">
        <div className="border border-border rounded-xl p-8 sm:p-12 bg-background">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 rounded-full bg-muted border border-border mb-6">
              <Sparkles className="w-3.5 h-3.5 text-foreground/60" />
              <span className="text-xs sm:text-sm font-medium text-foreground/80">Early Access</span>
            </div>

            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 tracking-tight">
              Build smarter systems, not longer nights.
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground mb-8 sm:mb-10 max-w-xl mx-auto font-light">
              Join the waitlist and be among the first to experience AI-powered bug fixing. 
              Get 20 free fixes when we launch.
            </p>

            <div className="mb-8">
              <WaitlistCTA source="CTA Section" />
            </div>

            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-muted-foreground mb-6">
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-foreground/40" />
                <span>No credit card required</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-foreground/40" />
                <span>20 free fixes included</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-foreground/40" />
                <span>Launching Soon</span>
              </div>
            </div>

            <Link to="/cost-calculator">
              <Button variant="outline" size="lg" className="gap-2">
                <Calculator className="w-4 h-4" />
                Calculate Your Savings
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};